import styled from "styled-components";

export const EditorWrapper = styled("div")`
  .editor-wrapper {
    border: 1px solid #00000010;
  }
`;
